$(document).ready(function () {
    var $status = $('.slide_dots');
    var $slickElement = $('.media-carousel .slides');

    $slickElement.on(
        'init reInit afterChange',
        function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.html(
                `<li class="text_3 pagination-item">` +
                    i +
                    `</li><li class="text_3 pagination-item">/</li>` +
                    `<li class="text_3 pagination-item">` +
                    slick.slideCount +
                    `</li>`
            );
        }
    );

    //- Media Gallery

    $('.media-carousel-expanded .slides').slick({
        speed: 300,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        variableHeight: true,
        touchThreshold: 10,
        adaptiveHeight: true,
        centerMode: true,
    });

    //- Inline  Gallery
    $('.media-carousel-inline .slides').slick({
        speed: 300,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 10,
        centerMode: true,
        adaptiveHeight: true,
        // variableWidth: true
        // variableHeight: true
    });

    //- Video Eposides
    $('.video-episodes_wrapper .slides').slick({
        speed: 400,
        prevArrow: $('.video-episodes_wrapper .slick-prev'),
        nextArrow: $('.video-episodes_wrapper .slick-next'),
        slidesToShow: 5,
        touchThreshold: 10,
        responsive: [
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 4,
                    swipeToSlide: true,
                },
            },
            {
                breakpoint: 820,
                settings: {
                    slidesToShow: 3,
                    variableWidth: true,
                    swipeToSlide: true,
                },
            },
        ],
    });

    //- Videos
    $('.video_wrapper').each(function () {
        var slidez = $(this).find('.slides');
        slidez.slick({
            nextArrow: slidez.parent().find('.slick-next'),
            prevArrow: slidez.parent().find('.slick-prev'),
            speed: 400,
            slidesToShow: 4,
            touchThreshold: 10,
            focusOnSelect: false,
            responsive: [
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 4,
                        swipeToSlide: true,
                    },
                },
                {
                    breakpoint: 820,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: true,
                        swipeToSlide: true,
                    },
                },
            ],
        });
    });
});

//- Videos Home Gallery
$('.video-home_wrapper .slides').slick({
    speed: 400,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 10,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
});

//-Magazine Gallery
//$(".magazine_wrapper .slides").slick({
// speed: 20000,
// autoplay: true,
// autoplaySpeed: 0,
// cssEase: "linear",
// slidesToShow: 1,
// slidesToScroll: 1,
// variableWidth: true,
// arrows: false
//});

//- Newsletter promo
$('.newsletter_wrapper .slides').slick({
    speed: 300,
    prevArrow: $('.slick-prev'),
    nextArrow: $('.slick-next'),
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 10,
    arrows: true,
    dots: true,
    responsive: [
        {
            breakpoint: 820,
            settings: {
                arrows: false,
            },
        },
    ],
});

/* ARTICLE SLIDER */
/* **** MDL FULL SIZE SLIDER   ***** */
const addSlidesToSlickSlider = () => {
    if (
        $('.mdl-slider').length &&
        $('.mdl-slider').find('.mdl-slider__item').length == 0
    ) {
        $(".js-img-to-slider-wrap img:not('.js-exclude-from-slider')").each(
            function () {
                $(this).css('cursor', 'pointer');
                let src = $(this).attr('src'),
                    $slide = $(
                        `
                    <div class="mdl-slider__item">
                        <figure class="mdl-slider__media">
                            <div class="mdl-slider__media-content">
                              <img
                                class="mdl-slider__img"
                                src="` +
                            src +
                            `"
                                alt=""
                              />
                            </div>
                        </figure>
                    </div>
                  `
                    );
                $slide.appendTo('.mdl-slider');
            }
        );
    }
};

$(document).ready(function () {
    addSlidesToSlickSlider();

    if ($('.mdl-slider').length) {
        var $status = $('.mdl__slider-dots');
        var $slickElement = $('.mdl-slider');

        $slickElement.on(
            'init reInit afterChange',
            function (event, slick, currentSlide, nextSlide) {
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                var i = (currentSlide ? currentSlide : 0) + 1;
                $status.html(
                    `<li class="mdl__slider-dot">` +
                        i +
                        `</li><li class="mdl__slider-dot">/</li>` +
                        `<li class="mdl__slider-dot">` +
                        slick.slideCount +
                        `</li>`
                );
            }
        );

        var mdlOptions = {
            arrows: true,
            dots: false,
            //common options
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
            infinite: true,
            draggable: true,
            swipe: true,
            touchMove: true,
            adaptiveHeight: true,
        };
        $('.mdl-slider').slick(mdlOptions);
    }
});

$(document).ready(function () {
    $(document).on(
        'click',
        ".js-img-to-slider-wrap img:not('.js-exclude-from-slider')",
        function () {
            if ($('.touchevents').length) {
                overlayStart();
            }
            $('#mdl-full-size-slider').addClass('active');

            $(".js-img-to-slider-wrap img:not('.js-exclude-from-slider')").each(
                function (i) {
                    $(this).attr('data-index', i);
                }
            );
            var index = $(this).attr('data-index');

            $('.mdl-slider').slick('slickGoTo', index);
            $('.mdl-slider').slick('refresh');
        }
    );
});

$(document).ready(function () {
    $('.article__slider__items').slick({
        speed: 300,
        infinite: false,
        dotsClass: 'article__slider__dots',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    adaptiveHeight: true,
                },
            },
        ],
    });
});

$('.article__slider__items').on(
    'init reInit afterChange',
    function (event, slick, currentSlide, nextSlide) {
        $('.article__slider__count__current').text(
            (currentSlide ? currentSlide : 0) + 1
        );
        $('.article__slider__count__max').text(slick.slideCount);
    }
);

$(document).ready(function () {
    function navCardsSlider() {
        let additionalIndent = 32;
        if ($('body').width() < 768) {
            additionalIndent = 16;
        }
        let slidesCount = 0;
        $('.nav-cards__wrapper').slick({
            arrows: true,
            dots: false,
            speed: 300,
            variableWidth: true,
            fade: false,
            infinite: false,
            draggable: true,
            swipe: true,
            touchMove: true,
            prevArrow: $('.nav-cards__slider__arrow__left'),
            nextArrow: $('.nav-cards__slider__arrow__right'),
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                // {
                //     breakpoint: 834,
                //     settings: {
                //         swipe: true,
                //         slidesToShow: 2,
                //     },
                // },
                // {
                //     breakpoint: 768,
                //     settings: {
                //         slidesToShow: 3,
                //     },
                // },
                {
                    breakpoint: 660,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 434,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
        $('.nav-cards__wrapper')
            .find('.nav-cards__item')
            .each(function () {
                slidesCount += 1;
            });
        $('.nav-cards__wrapper').on(
            'beforeChange',
            function (event, slick, currentSlide, nextSlide) {
                let slideWidth =
                    $(this).find('.nav-cards__item').outerWidth() +
                    additionalIndent;
                let sliderWrapperWidth = $('body').width();
                let countSlidesShow = Math.floor(
                    $(window).width() / slideWidth
                );

                let addOffetForLastslider =
                    sliderWrapperWidth - slideWidth * countSlidesShow;
                if (nextSlide == slidesCount - countSlidesShow) {
                    $(this)
                        .find('.nav-cards__item')
                        .css(
                            'transform',
                            `translateX(${
                                addOffetForLastslider - additionalIndent
                            }px)`
                        );
                } else {
                    $(this)
                        .find('.nav-cards__item')
                        .css('transform', `translateX(${0}px)`);
                }
            }
        );
    }

    $(window).resize(function () {
        var parentWidth = $('.nav-cards__wrapper').width();

        var childrenWidth = -0.1;
        $('.nav-cards__item').each(function () {
            childrenWidth += $(this).outerWidth(true);
        });

        if (childrenWidth > parentWidth) {
            if (!$('.nav-cards__wrapper').hasClass('slick-initialized')) {
                navCardsSlider();
                $('.nav-cards__slider__arrow').css('display', 'flex');
            }
        } else {
            if ($('.nav-cards__wrapper').hasClass('slick-initialized')) {
                setTimeout(function () {
                    $('.nav-cards__wrapper').slick('unslick');
                    $('.nav-cards__slider__arrow').css('display', 'none');
                }, 250);
            }
        }
    });
});
